export const USER_LOGG_IN_REQUEST = 'USER_LOGG_IN_REQUEST'
export const USER_LOGG_IN_REQUEST_COMPLETED = 'USER_LOGG_IN_REQUEST_COMPLETED'
export const USER_LOGG_IN_REQUEST_ERROR = 'USER_LOGG_IN_REQUEST_ERROR'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const USER_PREFFERED_TEAM = 'USER_PREFFERED_TEAM'

export const USER_PHOTO_REQUEST = 'USER_PHOTO_REQUEST'
export const USER_PHOTO_REQUEST_COMPLETED = 'USER_PHOTO_REQUEST_COMPLETED'
export const USER_PHOTO_REQUEST_ERROR = 'USER_PHOTO_REQUEST_ERROR'

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_REQUEST_COMPLETED = 'FETCH_USER_REQUEST_COMPLETED';
export const FETCH_USER_REQUEST_ERROR = 'FETCH_USER_REQUEST_ERROR';
export const FETCH_USER_REQUEST_RESET = 'FETCH_USER_REQUEST_RESET';

export const FETCH_USER_LIST_REQUEST = 'FETCH_USER_LIST_REQUEST';
export const FETCH_USER_LIST_REQUEST_COMPLETED = 'FETCH_USER_LIST_REQUEST_COMPLETED';
export const FETCH_USER_LIST_REQUEST_ERROR = 'FETCH_USER_LIST_REQUEST_ERROR';
export const FETCH_USER_LIST_REQUEST_RESET = 'FETCH_USER_LIST_REQUEST_RESET';

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_REQUEST_COMPLETED = 'ADD_USER_REQUEST_COMPLETED';
export const ADD_USER_REQUEST_ERROR = 'ADD_USER_REQUEST_ERROR';

export const GRANT_USER_REQUEST = 'GRANT_USER_REQUEST';
export const GRANT_USER_REQUEST_COMPLETED = 'GRANT_USER_REQUEST_COMPLETED';
export const GRANT_USER_REQUEST_ERROR = 'GRANT_USER_REQUEST_ERROR';

export const ACTION_USER_REQUEST = 'ACTION_USER_REQUEST';
export const ACTION_USER_REQUEST_COMPLETED = 'ACTION_USER_REQUEST_COMPLETED';
export const ACTION_USER_REQUEST_ERROR = 'ACTION_USER_REQUEST_ERROR';

export const DELETE_USER_ROLE_REQUEST = 'DELETE_USER_ROLE_REQUEST';
export const DELETE_USER_ROLE_REQUEST_COMPLETED = 'DELETE_USER_ROLE_REQUEST_COMPLETED';
export const DELETE_USER_ROLE_REQUEST_ERROR = 'DELETE_USER_ROLE_REQUEST_ERROR';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_REQUEST_COMPLETED = 'CHANGE_PASSWORD_REQUEST_COMPLETED';
export const CHANGE_PASSWORD_REQUEST_ERROR = 'CHANGE_PASSWORD_REQUEST_ERROR';




// WEBPACK FOOTER //
// ./constants/userdetails.js